export default [
    {
        field: 'username',
        editable: false,
        sortable: true,
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('username', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.username
        },
    },
    {
        field: 'title',
        editable: true,
        sortable: true,
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('title', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.title
        },
    },
    {
        headerName: 'First Name',
        editable: true,
        sortable: true,
        field: 'first_name',
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('first_name', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.first_name
        },
    },
    {
        headerName: 'Last Name',
        editable: true,
        sortable: true,
        field: 'last_name',
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('last_name', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.last_name
        },
    },
    {
        headerName: 'Email',
        editable: true,
        sortable: true,
        field: 'email',
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('email', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.email
        },
    },
    {
        headerName: 'Status',
        editable: true,
        sortable: true,
        field: 'status',
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('status', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.status
        },
    },
    {
        headerName: 'Send Notifications',
        editable: true,
        sortable: true,
        field: 'send_notifications',
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('send_notifications', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.send_notifications
        },
    },
    {
        headerName: 'Time Updated',
        field: 'time_updated',
        sortable: true,
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('time_updated', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.time_updated
        },
    },
    {
        field: 'department_approver_workflow',
        editable: true,
        sortable: true,
        headerName: 'Dept Approver Workflow',
        valueFormatter: (params) => {
            if (!params || typeof params.value === 'undefined') return 'View Only'
            switch (String(params.value)) {
                case '0':
                    return 'View Only'

                case '1':
                    return 'View/Edit'

                default:
                    return 'View Only'
            }
        },
        valueSetter: (params) => {
            let resource = params.data.managers.user_id.resource
            resource.set('department_approver_workflow', params.newValue)
        },
        valueGetter: (params) => {
            let userResource = params.data.managers.user_id.resource
            return userResource.attributes.department_approver_workflow
        },
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
            values: ['0', '1'],
        },
    },
]
